import { render, staticRenderFns } from "./StaticInfoField.vue?vue&type=template&id=10893916"
import script from "./StaticInfoField.vue?vue&type=script&lang=js"
export * from "./StaticInfoField.vue?vue&type=script&lang=js"
import style0 from "./StaticInfoField.vue?vue&type=style&index=0&id=10893916&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports